import pagesApi from "@/api/pages.js";

const state = {
    isLoading: false,
    validationErrors: null,
    menuItems: [],
    currentPage: null
};

export const mutationTypes = {
    getPagesStart: "[pages] getPagesStart",
    getPagesSuccess: "[pages] getPagesSuccess",
    getPagesFailure: "[pages] getPagesFailure",

    getPageBySlugStart: "[pages] getPageBySlugStart",
    getPageBySlugSuccess: "[pages] getPageBySlugSuccess",
    getPageBySlugFailure: "[pages] getPageBySlugFailure",

};

export const actionTypes = {
    getPages: "[pages] getPages",
    getPageBySlug: "[pages] getPageBySlug"
};

const mutations = {
    [mutationTypes.getPagesStart](state) {
        state.isLoading = true;
        state.error = null;
    },
    [mutationTypes.getPagesSuccess](state, items) {
        state.isLoading = false;
        state.menuItems = items;
    },
    [mutationTypes.getPagesFailure](state, error) {
        state.isLoading = false;
        state.error = error;
    },


    [mutationTypes.getPageBySlugStart](state) {
        state.isLoading = true;
        state.error = null;
        state.currentPage = null;
    },
    [mutationTypes.getPageBySlugSuccess](state, data) {
        state.isLoading = false;
        state.currentPage = data;
    },
    [mutationTypes.getPageBySlugFailure](state, error) {
        state.isLoading = false;
        state.currentPage = null;
        state.error = error;
    }
};

const actions = {
    async [actionTypes.getPages]({ commit }) {
        commit(mutationTypes.getPagesStart);
        try {
            const response = await pagesApi.getPages();
            if (response.data.status === "SUCCESS") {
                commit(mutationTypes.getPagesSuccess, response.data.result);
            } else {
                commit(mutationTypes.getPagesFailure, response.data.message);
            }
        } catch (error) {
            commit(mutationTypes.getPagesFailure, error);
            console.error("Ошибка при запросе страниц", error);
        }
    },

    async [actionTypes.getPageBySlug]({ commit }, payload) {
        const slug = typeof payload === 'string' ? payload : payload?.slug;
        const previewToken = typeof payload === 'string' ? undefined : payload?.previewToken;
        commit(mutationTypes.getPageBySlugStart);
        try {
            const response = await pagesApi.getPageBySlug(slug, previewToken);
            if (response.data.status === "SUCCESS") {
                commit(mutationTypes.getPageBySlugSuccess, response.data.result);
                return response.data.result;
            }
            commit(mutationTypes.getPageBySlugFailure, response.data);
            throw new Error(response.data?.message || 'Page not found');
        } catch (error) {
            commit(mutationTypes.getPageBySlugFailure, error);
            console.error("Ошибка при запросе страницы", error);
            throw error;
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
